import { __awaiter } from "tslib";
import s3 from '@/requests/s3';
import { status } from '@/alas';
import { defineComponent, reactive } from '@vue/composition-api';
export default defineComponent({
    props: ['type', 'picture'],
    setup(props) {
        let $ = reactive({
            config: status.fetch('userConfig')
        });
        let tagDisabled = (tag) => {
            if (props.picture.tags.includes(tag.key)) {
                return false;
            }
            return props.picture.tags.length === $.config.pictureTagLimit;
        };
        let uploaded = (key) => __awaiter(this, void 0, void 0, function* () {
            let file = yield s3.getImageBlob(key);
            yield s3.uploadImage({
                file,
                name: props.picture.$v.miniImage,
                width: 1440 / 2.5,
                height: 1440 / 2.5,
                quality: 0.6
            });
        });
        return {
            $,
            uploaded,
            tagDisabled
        };
    }
});
